import { Icon, IconProps } from './Icon';

export const DurationsIcon = ({ ...props }: IconProps) => (
  <Icon
    {...props}
    viewBox="0 0 20 20"
  >
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M6.24992 2.5V5"
        stroke="#5E6A81"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7499 2.5V5"
        stroke="#5E6A81"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="2.5"
        y="3.75"
        width="15"
        height="13.75"
        rx="3"
        stroke="#5E6A81"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8333 13.3327H13.7499"
        stroke="#5E6A81"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.25 13.1288L6.94143 13.75L8.33333 12.5"
        stroke="#5E6A81"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8333 9.16667H13.7499"
        stroke="#5E6A81"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.25 8.96273L6.94143 9.58398L8.33333 8.33398"
        stroke="#5E6A81"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </Icon>
);
